import classNames from 'classnames'
import React from 'react'
import RectLoader from '../rect-loader/index.jsx'

import './styles.scss'

const TableLoader = ({ className, rows = 6 }) => {
  return (
    <div className={classNames('table-loader', className)}>
      <For each="row" of={new Array(rows).fill(0, 0, rows)} index="index">
        <div key={`${index}`} className="table-loader__row">
          <RectLoader width={100} height={16} />
          <RectLoader width={100} height={16} />
          <RectLoader width={100} height={16} />
          <RectLoader width={100} height={16} />
        </div>
      </For>
    </div>
  )
}

export default TableLoader
